import type { AgentSceneConfig, AgentSceneType } from '@/app/types';

/** Agent 场景设置配置 */
export const AGENT_SCENE_SETTINGS_CONFIG: Record<AgentSceneType, AgentSceneConfig['settingsConfig']> = {
  common: {
    duration: [15, 30],
    resolution: ['Resolution_1080p'],
    ratio: ['Ratio_9_16', 'Ratio_3_4', 'Ratio_1_1', 'Ratio_16_9', 'Ratio_4_3'],
  },
  e_commerce: {
    duration: [15, 30],
    resolution: ['Resolution_1080p'],
    ratio: ['Ratio_9_16', 'Ratio_3_4', 'Ratio_1_1', 'Ratio_16_9', 'Ratio_4_3'],
  },
  remake: {
    duration: [15, 30],
    resolution: ['Resolution_1080p'],
    ratio: ['Ratio_9_16', 'Ratio_3_4', 'Ratio_1_1', 'Ratio_16_9', 'Ratio_4_3'],
  },
};

/** 场景输入配置 */
export const SCENE_INPUT_CONFIG: Record<AgentSceneType, AgentSceneConfig['inputConfig']> = {
  common: {
    allowInputTypes: ['image', 'video'],
    inputTypesLimit: {
      image: 7,
      video: 1,
    },
  },
  e_commerce: {
    allowInputTypes: ['image'],
    inputTypesLimit: {
      image: 7,
    },
  },
  remake: {
    allowInputTypes: ['image', 'video'],
    inputTypesLimit: {
      image: 7,
      video: 1,
    },
  },
};

export const DEFAULT_SCENE_ID: AgentSceneType = 'common';

/** 免费项目数量 */
export const MAX_FREE_PROJECTS_COUNT = 10;
